module.exports = __webpack_public_path__ + "media/images/badges/purebarre/PureBarre-750-Classes-Active-68028068b24296127094bf85398c6c34.png";